// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/reservoir_mutation.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {proto3} from "@bufbuild/protobuf";
import {Reservoir} from "./system_pb.js";
import {TranslatableError} from "./system_mutation_pb.js";

/**
 * @generated from message wavin.aqora.v2.CreateReservoirRequest
 */
export const CreateReservoirRequest = proto3.makeMessageType(
  "wavin.aqora.v2.CreateReservoirRequest",
  () => [
    {no: 1, name: "topology_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateReservoirRequest
 */
export const UpdateReservoirRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateReservoirRequest",
  () => [
    {no: 1, name: "reservoir", kind: "message", T: Reservoir},
    {no: 2, name: "use_target_percentage", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateReservoirsPositionRequest
 */
export const UpdateReservoirsPositionRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateReservoirsPositionRequest",
  () => [
    {no: 1, name: "positions", kind: "message", T: UpdateReservoirsPositionRequest_Position, repeated: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateReservoirsPositionRequest.Position
 */
export const UpdateReservoirsPositionRequest_Position = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateReservoirsPositionRequest.Position",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "x", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 3, name: "y", kind: "scalar", T: 5 /* ScalarType.INT32 */},
  ],
  {localName: "UpdateReservoirsPositionRequest_Position"},
);

/**
 * @generated from message wavin.aqora.v2.UpdateReservoirsPositionResponse
 */
export const UpdateReservoirsPositionResponse = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateReservoirsPositionResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.ReservoirResponse
 */
export const ReservoirResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ReservoirResponse",
  () => [
    {no: 1, name: "success", kind: "message", T: ReservoirResponse_Success, oneof: "outcome"},
    {no: 2, name: "failure", kind: "message", T: ReservoirResponse_Failure, oneof: "outcome"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.ReservoirResponse.Field
 */
export const ReservoirResponse_Field = proto3.makeEnum(
  "wavin.aqora.v2.ReservoirResponse.Field",
  [
    {no: 0, name: "FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FIELD_NAME", localName: "NAME"},
    {no: 2, name: "FIELD_TITLE", localName: "TITLE"},
    {no: 3, name: "FIELD_AREA_M2", localName: "AREA_M2"},
    {no: 4, name: "FIELD_MIN_WATER_HEIGHT_MM", localName: "MIN_WATER_HEIGHT_MM"},
    {no: 5, name: "FIELD_MAX_WATER_HEIGHT_MM", localName: "MAX_WATER_HEIGHT_MM"},
    {no: 6, name: "FIELD_TARGET_GROWING_SEASON", localName: "TARGET_GROWING_SEASON"},
    {no: 7, name: "FIELD_TARGET_OTHER", localName: "TARGET_OTHER"},
    {no: 8, name: "FIELD_FACTOR_HOLLOW", localName: "FACTOR_HOLLOW"},
    {no: 9, name: "FIELD_UI_POSITION", localName: "UI_POSITION"},
    {no: 10, name: "FIELD_TYPE_PROPERTIES", localName: "TYPE_PROPERTIES"},
    {no: 11, name: "FIELD_MIN_WATER_PERCENTAGE", localName: "MIN_WATER_PERCENTAGE"},
    {no: 12, name: "FIELD_TARGET_GROWING_SEASON_PERCENTAGE", localName: "TARGET_GROWING_SEASON_PERCENTAGE"},
    {no: 13, name: "FIELD_TARGET_OTHER_PERCENTAGE", localName: "TARGET_OTHER_PERCENTAGE"},
    {no: 20, name: "FIELD_GREEN_ROOF_AREA_GREEN", localName: "GREEN_ROOF_AREA_GREEN"},
    {no: 21, name: "FIELD_GREEN_ROOF_GREEN_TYPE", localName: "GREEN_ROOF_GREEN_TYPE"},
    {no: 30, name: "FIELD_SEWER_LIMITATIONS", localName: "SEWER_LIMITATIONS"},
    {no: 40, name: "FIELD_INFILTRATION_TANK_K_FACTOR", localName: "INFILTRATION_TANK_K_FACTOR"},
    {no: 41, name: "FIELD_INFILTRATION_DRAINAGE_SPEED", localName: "INFILTRATION_DRAINAGE_SPEED"},
    {no: 50, name: "FIELD_POND_NAP_OFFSET", localName: "POND_NAP_OFFSET"},
    {no: 60, name: "FIELD_WADI_MAX_VOLUME", localName: "WADI_MAX_VOLUME"},
    {no: 61, name: "FIELD_WADI_DRAINAGE_SPEED", localName: "WADI_DRAINAGE_SPEED"},
    {no: 70, name: "FIELD_TANK_DRY_PROTECTION", localName: "TANK_DRY_PROTECTION"},
    {no: 71, name: "FIELD_TANK_EXTERNAL_USAGE", localName: "TANK_EXTERNAL_USAGE"},
    {no: 72, name: "FIELD_TANK_CAPTURE_AREA", localName: "TANK_CAPTURE_AREA"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ReservoirResponse.Success
 */
export const ReservoirResponse_Success = proto3.makeMessageType(
  "wavin.aqora.v2.ReservoirResponse.Success",
  () => [
    {no: 1, name: "reservoir", kind: "message", T: Reservoir},
  ],
  {localName: "ReservoirResponse_Success"},
);

/**
 * @generated from message wavin.aqora.v2.ReservoirResponse.FieldError
 */
export const ReservoirResponse_FieldError = proto3.makeMessageType(
  "wavin.aqora.v2.ReservoirResponse.FieldError",
  () => [
    {no: 1, name: "field", kind: "enum", T: proto3.getEnumType(ReservoirResponse_Field)},
    {no: 2, name: "error", kind: "message", T: TranslatableError},
  ],
  {localName: "ReservoirResponse_FieldError"},
);

/**
 * @generated from message wavin.aqora.v2.ReservoirResponse.Failure
 */
export const ReservoirResponse_Failure = proto3.makeMessageType(
  "wavin.aqora.v2.ReservoirResponse.Failure",
  () => [
    {no: 1, name: "errors", kind: "message", T: TranslatableError, repeated: true},
    {no: 2, name: "field_errors", kind: "message", T: ReservoirResponse_FieldError, repeated: true},
  ],
  {localName: "ReservoirResponse_Failure"},
);

/**
 * @generated from message wavin.aqora.v2.DeleteReservoirRequest
 */
export const DeleteReservoirRequest = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteReservoirRequest",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeleteReservoirResponse
 */
export const DeleteReservoirResponse = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteReservoirResponse",
  [],
);

